import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  ContentChild,
  ContentChildren,
  AfterContentInit,
  HostListener,
  Renderer,
  AfterViewInit,
  Output,
  EventEmitter
} from "@angular/core";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { BaseComponent } from "../../core/component/Base.Component";
import { Router } from "@angular/router";
import { AppConstants } from "../../app.constant";
import { NavComponent } from "../../core/component/Nav.Component";
import { NavModalComponent } from "../../core/component/NavModal.Component";
import { LookupResult } from "../lookup/lookup.config";
import { DataTransferObject } from "../../core/entities/DataTransferObject";
import { Subscription } from "rxjs/Subscription";
import {
  MessageBoxSettings,
  MessageBoxResult,
  MessageBoxResultType
} from "../messagebox/messagebox.config";
import { MessageBoxComponent } from "../messagebox/messagebox.component";
import { Enum, customButton, customButtonList } from "../config";
import { List } from "linqts";
import * as $ from "jquery";

@Component({
  selector: "ixs-modal",
  templateUrl: "ixsmodal.component.html",
  styles: [".btn-xs1{width:88px !important;}"],
  styleUrls: ["../toolbar/toolbar.scss"],
  
})
export class IXSModalComponent extends BaseComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    this.zindex += Number(this.lvl);
    this.loadData();
  }
  private lookupSubscription: Subscription;

  @ViewChild("ixsmodal")
  public modal: ModalComponent;

  @ContentChild("ngContent") screen: NavModalComponent<any>;

  @Input()
  showList: boolean = false;

  @Output()
  toolbarClickList: EventEmitter<customButtonList> = new EventEmitter<
    customButtonList
  >();

  private groups: any = [];

  private data: [customButtonList];

  @Input()

  set customButtonList(value: any) {

    this.data = value;
    this.loadData();
  }
  get customButtonList() {
    return this.data;
  }


  customButtonListClick(item: customButtonList) {
    this.toolbarClickList.emit(item);
  }

  @Input()
  public Caption: String;

  @Input()
  screenCode: string;

  width: string = Enum.modalSize.Large;
  height: string = "auto";

  @Input()
  modaltype: number = Enum.modalType.Normal;

  @Input()
  displayLastRecord: boolean = false;

  @Input()
  showClose: boolean = true;

  @Input()
  mode: number = Enum.Mode.Default;

  @Input() lvl: number = 1;

  @Input()
  modalSize: string = Enum.modalSize.Large;

  private zindex: number = 1049;

  constructor(private element: ElementRef, private renderer: Renderer) {
    super();
  }

  public triggeronOpen() {
    let event = new CustomEvent("onOpen", { detail: this, bubbles: true });
    this.renderer.invokeElementMethod(
      this.element.nativeElement,
      "dispatchEvent",
      [event]
    );
  }

  public triggeronClose() {
    let event = new CustomEvent("onClose", { detail: this, bubbles: true });
    this.renderer.invokeElementMethod(
      this.element.nativeElement,
      "dispatchEvent",
      [event]
    );
  }

  async ngOnInit() {
    this.modal.backdrop = "static";
    this.modal.keyboard = true;
  }
  // async drag() {
  //   $(".modal-dialog").draggable({
  //     handle: ".modal-header"
  //   });
  //   $("modal-dialog").css({ top: 0, left: 0, right: 0, bottom: 0 });
  // }
  async open(size: string = Enum.modalSize.Large) {
    // await this.drag();
    this.lookupSubscription = this.broadcast
      .observable<LookupResult>("lookup")
      .subscribe(arg => {
        switch (arg.value.lookupId) {
          case this.screenCode + "lister":
            this.screen.setDto(<DataTransferObject<any>>{
              Data: arg.value.data,
              KeyValue: arg.value.data.PrimaryKeyValue
            });
            break;
        }
      });

      this.Caption =  this.Caption && this.Caption === this.screen.title ? this.Caption : this.screen.title ? this.screen.title : "-" ;
    await this.screen.initialize();

    await this.modal.open(size);

    this.triggeronOpen();

    if (this.displayLastRecord && this.mode !== Enum.Mode.New) {
      await this.screen.moveLast();
    }

    // await this.course.moveLast();
  }

  async customOpen(size: string = Enum.modalSize.Large) {

    // await this.drag();
    await this.modal.open(size);
    if (this.screen) {
      await this.screen.initialize();
    }
    this.triggeronOpen();
  }

  async customModalSize(width: string, height?: string) {

    if (this.modaltype === Enum.modalType.Custom) {
      if (width || height) {

        var tab = document.getElementsByClassName("custom");
        $(tab[0].children[0]).css({ width: width, height: height });
        $(tab[0].children[0].children[0]).css({ width: width, height: height });
        $(tab[0]).css({ top: 0, left: 0, right: 0, bottom: 0, display: 'inline', position: 'fixed' });
        await this.modal.open();
      }
      else {

        await this.modal.open();
      }
      // await this.drag();

      if (this.screen) {

        await this.screen.initialize();
      }

      this.triggeronOpen();

    }
  }

  showModalLister() {
    this.screen.showLister(this.screenCode + "lister");
  }

  async deleteModalData() {
    await this.screen.confirmDelete();
  }

  close(triggerclose: boolean = true) {
    if (this.lookupSubscription) {
      this.lookupSubscription.unsubscribe();
    }

    if (this.screen && this.screen.service) {
      this.screen.service.clearCondition();
    } else {
      this.modal.close();
    }

    if (triggerclose) this.triggeronClose();
  }

  async saveAndClose() {
    const issuccess = await this.screen.save();

    if (issuccess) {
      this.modal.close();
      this.close();
    }
  }

  async Close() {
    this.modal.close();
    this.close();
  }

  private async innerClose() {
    if (this.screen && this.screen.service) {
      this.screen.service.clearCondition();
      await this.screen.clear();
    }
  }

  private onlyClose() {
    this.modal.close();
    this.close(false);
  }

  @Input()
  hideNew: boolean = false;

  @Input()
  hideSave: boolean = false;

  @Input()
  hideSaveClose: boolean = false;

  @Input()
  hideClose: boolean = false;

  private async loadData() {

    if (this.data) {

      this.groups = new List<customButtonList>(this.data)
        .Select(o => o.grpname === "" || o.grpname === null || o.grpname === undefined ? "Options" : o.grpname)
        .Distinct()
        .ToArray();


    }
  }

  filterData(grp): Array<customButtonList> {
    if (grp === "Options") {
     
      grp = undefined;

      return this.data.filter(o => o.grpname === grp);
    }
    else {
      return this.data.filter(o => o.grpname === grp);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/ixsmodal/ixsmodal.component.ts